import React from 'react';

/**
 * Bloc Puck — Espace vertical. Hauteur = longueur CSS (rem stockée, px
 * affichés dans le champ, cf. puckPxSpacingField) ; vide = pas d'espace.
 */
const Spacer = ({ height = '2rem' }) => (
  <div style={{ height: height || 0, width: '100%', flexShrink: 0 }} aria-hidden="true" />
);

export default Spacer;
